class Link {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
        this.classOpen = 'menu--is-open'
    }
    run() {
        document.querySelectorAll('[data-link-async]').forEach((el) => new LinkAsync(el, this))
    }
}

class LinkAsync {
    constructor(el, parent) {
        this.parent = parent
        this.el = el
        this.init()
    }

    init() {
        this.el.addEventListener('click', this.actionaHandler)
    }

    actionaHandler(ev) {
        document.body.classList.add('loading')
    }
}

export default Link